import types from '../types/user';
import alertTypes from '../types/alerts';

export const initLocalStorageSync = (dispatch) => {
  const handleStorageChange = (event) => {
    if (event.key !== 'user') {
      return;
    }

    if (event.newValue) {
      try {
        const updatedUser = JSON.parse(event.newValue);

        if (updatedUser.confirmed === true) {
          dispatch({
            type: alertTypes.ALERT_DISMISS_BY_HEADER,
            payload: 'Unconfirmed user',
          });
        }

        dispatch({
          type: types.SYNC_USER_FROM_STORAGE,
          payload: updatedUser,
        });
      } catch (error) {
        console.error('[LocalStorage Sync] Failed to parse user data:', error);
      }
    } else if (event.newValue === null) {
      dispatch({
        type: types.LOGOUT_SUCCESS,
      });
    }
  };

  window.addEventListener('storage', handleStorageChange);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
  };
};
